'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

exports.default = {
  'candy-apple': _colors.CANDY_APPLE_LIGHT,
  calypso: _colors.CALYPSO_LIGHT,
  koala: _colors.KOALA,
  lorax: _colors.LORAX_LIGHT,
  marigold: _colors.MARIGOLD_LIGHT,
  norman: _colors.NORMAN_LIGHT,
  oz: _colors.OZ_LIGHT,
  sorbet: _colors.SORBET_LIGHT,
  thunderdome: _colors.THUNDERDOME_LIGHT
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/core/LightColors.js
// module id = 1024
// module chunks = 2 3